import * as insurancesServices from './insurancesServices';

export { insurancesServices };
